import PropTypes from 'prop-types';
import { Box } from 'uiKit/atoms/Box/Box';
import { styled } from 'uiKit/atoms/styled/styled';
import { IconButton } from 'uiKit/atoms/IconButton/IconButton';
import { FirstPage } from 'uiKit/atoms/FirstPage/FirstPage';
import { KeyboardArrowLeft } from 'uiKit/atoms/KeyboardArrowLeft/KeyboardArrowLeft';
import { KeyboardArrowRight } from 'uiKit/atoms/KeyboardArrowRight/KeyboardArrowRight';
import { LastPage } from 'uiKit/atoms/LastPage/LastPage';

const Root = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  marginLeft: theme.spacing(2.5),
}));

const TablePaginationActions = ({ count, page, rowsPerPage, onPageChange }) => {
  const handleFirstPageButtonClick = event => onPageChange(event, 0);
  const handleBackButtonClick = event => onPageChange(event, page - 1);
  const handleNextButtonClick = event => onPageChange(event, page + 1);
  const handleLastPageButtonClick = event => onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));

  return (
    <Root>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
        data-testid="TablePaginationFirst"
      >
        <FirstPage />
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
        data-testid="TablePaginationPrevious"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
        data-testid="TablePaginationNext"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
        data-testid="TablePaginationLast"
      >
        <LastPage />
      </IconButton>
    </Root>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  onPageChange: PropTypes.func,
};

export default TablePaginationActions;
